function Uploader() {
    this.upload = function (data, cb, errCb) {
        if (errCb) {
            errCb({name: "NotImplemented", description: "Uploader.upload() is not implemented"})
        }
    };
}